import React, {Fragment, useState, useRef, useLayoutEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {Button, Modal} from "react-bootstrap";
import { PhotoProvider, PhotoView } from 'react-photo-view';
//import {rateDishAction} from "../../../../store/actions/RestaurantActions";
import {ReactComponent as Minus} from "../../../../icons/minus.svg";
import {ReactComponent as Plus} from "../../../../icons/plus.svg";
import {ReactComponent as Timer} from "../../../../icons/timer.svg";
import { useTranslation } from 'react-i18next';
import {translateRecord} from "../../../common/utils";
import QRcodeReader from "../../../common/QRcodeReader";
import swal from "sweetalert";
import {handleError} from "../../../../services/AlertService";
import {handleDishOrderCountAction, handleSelectDishVariationAction} from "../../../../store/actions/OrdersActions";

const Dish = (props) => {
  const dispatch = useDispatch();
  const storeOrders = useSelector(store => store.orders);
  const storeAuth = useSelector(store => store.auth);
  const [state, setState] = useState({
    showAll: false,
    showModificationsModal: false,
    showQuantityModal: false,
    quantity: props.dish.quantity
  });
  const dishMinHeightRef = useRef();
  const descriptionRef = useRef();
  const textarea = useRef();

  const [showLink, setShowLink] = useState(false);
  const [size, setSize] = useState([0, 0]);
  const { t } = useTranslation();

  // function rateDish(kind) {
  //   dispatch(rateDishAction(props.restaurant, props.category, props.dish, kind, props.index));
  // }

  useLayoutEffect(() => {
    if (dishMinHeightRef.current.scrollHeight > dishMinHeightRef.current.offsetHeight) {
      setShowLink(true);
    }
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  function updateSize() {
    setSize([window.innerWidth, window.innerHeight]);
  }

  function modsCount() {
    if (Object.keys(props.dish.dish_variations).length > 0 &&
        Object.values(props.dish.dish_variations).map((v) => v.uid)
        .some((item) => Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).includes(item)))
    {
      let result = 0;
      Object.keys(props.dish.dish_variations).forEach((vId) => {
        if (Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).includes(`v${vId}`)) {
          if (!!storeOrders.orderDishes[props.restaurant.slug].dishes[`v${vId}`].selectedMods) {
            result += Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes[`v${vId}`].selectedMods).length;
          }
        }
      });
      return result;
    } else if (!!storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid] &&
               !!storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid].selectedMods)
    {
      return Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid].selectedMods).length;
    }
  }

  function showModButton() {
    if (!!props.noPhoto && !!storeOrders.orderDishes[props.restaurant.slug]) {
      if (Object.keys(props.dish.dish_variations).length > 0 &&
          Object.values(props.dish.dish_variations).map((v) => v.uid)
          .some((item) => Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).includes(item)))
      {
        return Object.keys(props.dish.group_modifications).length > 0;
      } else if (!!storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid]) {
        return Object.keys(props.dish.group_modifications).length > 0;
      }
    } else {
      return false;
    }
  }

  const groupMods = (vary) => (
    <>
      { Object.values(props.dish.group_modifications).map((gMod, index) =>
        <div key={index}>
          <h6>{Object.values(gMod)[0].group_modification_name}</h6>
          { Object.values(gMod).map((dMod, i) =>
            <div className='order-dish' key={i}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center" style={{maxWidth: '66%'}}>
                  { (!!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods &&
                    !!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods[dMod.id]) &&
                  <Button className='order-count'
                          onClick={() => handleDishModificationCount(props.dish, dMod, -1, vary)}
                          style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01'}}
                  >
                    <strong>-</strong>
                  </Button>}
                  <div className='ml-2'>
                    <h6 className="mt-0 mb-0">{dMod.name}</h6>
                    <p className="text-muted mb-0 d-flex align-items-center">
                      <span className='mr-1 text-primary'>{dMod.price}<small>₴</small></span>
                      { (!!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods &&
                        !!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods[dMod.id]) &&
                      <Button className='btn-primary' style={{padding: '0 3px', borderRadius: '3px'}}>
                        x
                        <strong>
                          {storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods[dMod.id].quantity}
                        </strong>
                      </Button>}
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  { (!!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods &&
                    !!storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods[dMod.id]) &&
                  <span style={{color: '#F99724'}}>
                    <b>
                      {(parseFloat(dMod.price) * storeOrders.orderDishes[props.restaurant.slug].dishes[vary?.uid || props.dish.uid].selectedMods[dMod.id].quantity).toFixed(2)}<small>₴</small>
                    </b>
                  </span>}
                  <Button className='ml-2 order-count'
                          onClick={() => handleDishModificationCount(props.dish, dMod, 1, vary)}
                          style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'white' : '#130B01'}}
                  >
                    <strong>+</strong>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>)}
    </>
  );

  function handleDishOrderQuantity(dish, value, s) {
    const rSlug = props.restaurant.slug;
    const reducerDishes = {
      ...storeOrders.orderDishes,
      [rSlug]: {
        ...storeOrders.orderDishes[rSlug],
        dishes: {
          ...storeOrders.orderDishes[rSlug].dishes,
          [dish.uid]: {
            ...storeOrders.orderDishes[rSlug].dishes[dish.uid],
            quantity: parseFloat(value)
          }
        }
      }
    };
    dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
  }

  function handleDishModificationCount(dish, mod, count, vary) {
    const rSlug = props.restaurant.slug;
    const uid = vary?.uid || dish.uid;
    if (!!storeOrders.orderDishes[rSlug].dishes[uid].selectedMods) {
      if (!!storeOrders.orderDishes[rSlug].dishes[uid].selectedMods[mod.id]) {
        const quantity = parseFloat(storeOrders.orderDishes[rSlug].dishes[uid].selectedMods[mod.id].quantity);
        const newQuantity = quantity + count;
        let reducerDishes = {};
        if (newQuantity > 0) {
          reducerDishes = {
            ...storeOrders.orderDishes,
            [rSlug]: {
              ...storeOrders.orderDishes[rSlug],
              dishes: {
                ...storeOrders.orderDishes[rSlug].dishes,
                [uid]: {
                  ...storeOrders.orderDishes[rSlug].dishes[uid],
                  selectedMods: {
                    ...storeOrders.orderDishes[rSlug].dishes[uid].selectedMods,
                    [mod.id]: {
                      ...storeOrders.orderDishes[rSlug].dishes[uid].selectedMods[mod.id],
                      quantity: newQuantity
                    }
                  }
                }
              }
            }
          };
          dispatch(handleSelectDishVariationAction(storeOrders.orderDishes[rSlug].restaurant, reducerDishes))
        } else {
          let selectedMods = storeOrders.orderDishes[rSlug].dishes[uid].selectedMods;
          delete selectedMods[mod.id];
          reducerDishes = {
            ...storeOrders.orderDishes,
            [rSlug]: {
              ...storeOrders.orderDishes[rSlug],
              dishes: {
                ...storeOrders.orderDishes[rSlug].dishes,
                [uid]: {
                  ...storeOrders.orderDishes[rSlug].dishes[uid],
                  selectedMods: selectedMods
                }
              }
            }
          };
          dispatch(handleSelectDishVariationAction(storeOrders.orderDishes[rSlug].restaurant, reducerDishes))
        }
      } else {
        const reducerDishes = {
          ...storeOrders.orderDishes,
          [rSlug]: {
            ...storeOrders.orderDishes[rSlug],
            dishes: {
              ...storeOrders.orderDishes[rSlug].dishes,
              [uid]: {
                ...storeOrders.orderDishes[rSlug].dishes[uid],
                selectedMods: {
                  ...storeOrders.orderDishes[rSlug].dishes[uid].selectedMods,
                  [mod.id]: {
                    ...storeOrders.orderDishes[rSlug].dishes[uid].selectedMods[mod.id],
                    quantity: 1,
                    id: mod.id,
                    price: mod.price,
                    group_modification_id: mod.group_modification_id
                  }
                }
              }
            }
          }
        };
        dispatch(handleSelectDishVariationAction(storeOrders.orderDishes[rSlug].restaurant, reducerDishes))
      }
    } else {
      const reducerDishes = {
        ...storeOrders.orderDishes,
        [rSlug]: {
          ...storeOrders.orderDishes[rSlug],
          dishes: {
            ...storeOrders.orderDishes[rSlug].dishes,
            [uid]: {
              ...storeOrders.orderDishes[rSlug].dishes[uid],
              selectedMods: {
                [mod.id]: { quantity: 1, id: mod.id, price: mod.price, group_modification_id: mod.group_modification_id }
              }
            }
          }
        }
      };
      dispatch(handleSelectDishVariationAction(storeOrders.orderDishes[rSlug].restaurant, reducerDishes))
    }
  }

  function dishPrice() {
    if (storeOrders.orderCheckout.selectedOrderType === 'on_table' || storeOrders.orderCheckout.selectedOrderType === 'to_visit') {
      return parseFloat(props.dish.price);
    } else {
      return parseFloat(props.dish.price) + parseFloat(props.dish.box.price || 0);
    }
  }

  function dishVariationPrice(vary) {
    if (storeOrders.orderCheckout.selectedOrderType === 'on_table' || storeOrders.orderCheckout.selectedOrderType === 'to_visit') {
      return parseFloat(vary.price);
    } else {
      return parseFloat(vary.price) + parseFloat(vary.box.price || 0);
    }
  }

  return (
    <>
      { (props.fromDashboard || props.dish.available || (!props.dish.available && !!props.dish.not_available_text)) &&
        <div className='dish-wrapper dish card-body pt-0'
             style={props.restaurant.menu_type === 'full' && !props.noPhoto && !!props.dish.photo ?
         { backgroundSize: 'cover', backgroundPosition: 'center',
           backgroundImage: `linear-gradient(136deg, rgba(21, 13, 3, 0.9025) 15%, rgba(22, 15, 6, 0.82194) 30%, rgba(24, 17, 9, 0.739765) 40%, rgba(31, 22, 11, 0.1425) 100%), 
            url(${props.dish.photo})`} : {position: 'relative'}}
        >
          { !!props.dish.photo && !props.noPhoto &&
            <>
                <PhotoProvider speed={() => 200}
                               easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}
                >
                  <PhotoView src={props.dish.photo}>
                    <img src={props.dish.photo} loading="lazy"
                         className={props.restaurant.menu_type === 'full' ? 'dish-image' : "dish-image-right"}/>
                  </PhotoView>
                </PhotoProvider>
                <div style={ props.restaurant.menu_type === 'right' ? {backgroundSize: 'cover', backgroundPosition: 'center',
                    backgroundImage: `url(${props.dish.photo})`, borderRadius: 10,
                    position: 'absolute', top: '0', right: '0px', height: '100%', width: '50%'}
                  : {}}
                />
              </>}
          { !props.fromDashboard && !(props.variationsAvailable(props.dish)) &&
            <div style={{position: "absolute", top: '50%', transform: 'translateY(-50%)', left: '5%', width: '90%',
              boxShadow: '0px 2px 12px rgba(29, 10, 3, 0.2)',
              background: '#00000045', borderRadius: '10px', padding: '10px'}}
            >
              {/*<h1 className='ml-auto mr-auto text-center text-white mb-0'>Недоступно</h1>*/}
              <h6 className='text-white text-center ml-auto mb-0'>
                {translateRecord(props.dish, 'not_available_text')}
              </h6>
            </div>}
          { props.dish.new_dish &&
            <span style={{position: 'absolute', transform: 'rotate(326deg)', top: '3px', left: '-18px',
              textAlign: 'center', padding: '0 21px'}} className='btn-success fs-12'
            >
              <b>{t('new')}</b>
            </span>}
          <div className={`${!props.noPhoto && 'dish-min-height'} pt-3`} ref={dishMinHeightRef}
               style={{opacity: props.dish.available && props.variationsAvailable(props.dish) ? '1' : '0.5', position: 'relative'}}
          >
            <div className='dish-name d-flex align-items-baseline justify-content-between'>
              <h5 className='mb-0'
                  style={{lineHeight: 1.1, width: !props.noPhoto &&  !!props.dish.photo && props.restaurant.menu_type === 'right' ? '50%' : '100%', paddingRight: 10,
                    color: (!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ||
                      (props.restaurant.menu_type === 'full' && !props.noPhoto && !!props.dish.photo)) ? 'white' : '#2F2D2A', zIndex: 1,
                  }}
              >
                <p className='mb-0'>
                  <span>{translateRecord(props.dish, 'name')}</span>
                  { !!props.dish.cook_time &&
                    <>
                      <Timer width={20} height={15} fill={!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}/>
                      <span style={{fontSize: 12,
                        color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}}
                      >
                        від {props.dish.cook_time}хв
                      </span>
                    </>}
                </p>
                { Object.keys(props.dish.dish_variations).length === 0 &&
                    !!parseFloat(props.dishParameter(props.dish, 'weight')) &&
                  <span className="my-1 fs-14 mr-1" style={{color: '#F99724'}}>
                    {props.dishParameter(props.dish, 'weight')}
                  </span>}
                { (props.dish.weight_flag ?
                    Object.keys(props.dish.dish_variations).length === 0 &&
                      parseFloat(props.dish.min_order) > parseFloat(props.dish.weight)
                  :
                    !!props.dish.min_order && parseInt(props.dish.min_order) > 1) &&
                  <span className="my-1 fs-12">
                    <small>
                      { t('components.menu.minOrderFrom').toLowerCase()} {props.dish.weight_flag && !!props.dish.weight ?
                        <strong>
                          { Number.isInteger(parseFloat(props.dish.min_order)) ?
                            parseInt(props.dish.min_order)
                          :
                            props.dish.min_order}{t(`measures.${props.dish['measure']}`)}
                        </strong>
                      :
                        <strong>
                          { Number.isInteger(parseFloat(props.dish.min_order)) ?
                            parseInt(props.dish.min_order)
                          :
                            props.dish.min_order}{t('count')}
                        </strong>}
                    </small>
                  </span>}
              </h5>
              { !props.noPhoto &&
                <div className='dish-rate pl-3 mb-1' style={{position: 'relative', zIndex: 1}}>
                  <Button className={`btn btn-xxs ${!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? 'btn-dark' : 'btn-light'}`}
                          disabled={true}
                  >
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <i className='fa fa-thumbs-o-up'
                           style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}}
                          // onClick={() => rateDish('like')}
                        />
                        <span  style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}}>
                          {props.dish.likes}
                        </span>
                      </div>
                      <div className='d-flex align-items-center'>
                        <i className='fa fa-thumbs-o-down ml-2'
                           style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}}
                          // onClick={() => rateDish('dislike')}
                        />
                        <span style={{color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#BCBCBC' : '#8D8B89'}}>
                          {props.dish.dislikes}
                        </span>
                      </div>
                    </div>
                  </Button>
                </div>}
            </div>
            { props.restaurant.menu_type === 'right' && !props.noPhoto ?
              <>
                {/*<div style={{height: showLink && !state.showAll ? '20px' : '63px', overflow: 'hidden', position: 'relative'}}>*/}
                  <p style={{color: (state.showAll || !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark') ? 'white' : '#2F2D2A',
                    width: !props.noPhoto && props.dish.photo && !state.showAll ? '46%' : '100%', cursor: 'pointer',
                    position: state.showAll ? 'relative' : 'absolute', background: state.showAll ? '#00000095' : 'transparent',
                    borderRadius: '10px', padding: state.showAll ? '5px 10px' : 0, lineHeight: 1}}
                    className="mb-0" ref={descriptionRef}
                    onClick={() => setState({...state, showAll: !state.showAll})}
                  >
                    {translateRecord(props.dish, 'description')}
                  </p>
                {/*</div>*/}
                { showLink && !state.showAll && !!props.dish.photo && !props.noPhoto &&
                  <span className="show-more"
                        onClick={() => setState({...state, showAll: !state.showAll})}
                        style={{lineHeight: 0.6, background: storeAuth.auth.userData.theme === 'dark' ?
                            `linear-gradient(90deg, rgba(38, 38, 38, 0), rgba(38, 38, 38, 1))`
                            :
                            `linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))`}}
                  >...</span>}
              </>
            :
              <p className="mb-0"
                 style={{color: (!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' || (!props.noPhoto && !!props.dish.photo)) ? 'white' : '#2F2D2A'}}
              >
                {translateRecord(props.dish, 'description')}
              </p>}
            { showModButton() &&
              <Button className='btn-xxs btn-rounded btn-secondary mt-2 position-relative'
                      onClick={() => setState({...state, showModificationsModal: true})}
              >
                + Додатки {modsCount() > 0 && <span className='unpaid-paychecks' style={{color: 'white'}}>{modsCount()}</span>}
              </Button>}
          </div>
          <div className='mt-2' style={{display: "flex", alignItems: "end", justifyContent: "space-between", zIndex: 2,
            height: 40, opacity: props.dish.available && props.variationsAvailable(props.dish) ? '1' : '0.5'}}
          >
            { Object.keys(props.dish.dish_variations).length > 0 ?
              <div className='dish-variations'>
                <div className='subcategories py-1' style={{borderRadius: '12px', justifyContent: 'space-between'}}>
                  { Object.values(props.dish.dish_variations).map((v,i) =>
                    <Button className={`mr-1 btn-xs py-0 px-0 d-flex align-items-center`}
                            key={i} style={{zIndex: 1, position: 'relative', color: '#2f2d2a'}}
                            disabled={!props.fromDashboard && !(props.category.available && props.dish.available && v.available)}
                            variant={!!storeOrders.orderDishes[props.restaurant.slug] &&
                            !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid] ? 'primary' : 'light'}
                            onClick={() => !!props.category.price && props.selectComplexDish(props.dish, v, props.category)}
                    >
                      { !props.category.price && !!storeOrders.orderDishes[props.restaurant.slug] &&
                          !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid] &&
                        <div className='pr-1 ml-1' style={{borderRadius: '10px', lineHeight: 3}}
                          onClick={() => props.countDishVariation(props.dish, v, -1)}
                        >
                          <span className='btn-light btn-rounded btn-xxs' style={{padding: '9px 6px 0'}}>
                            <span className='fs-28'><b>-</b></span>
                          </span>
                        </div>}
                      <div onClick={() => (props.acceptOutsideOrders || props.table) && !props.category.price &&
                          props.selectDishVariation(props.dish, v, props.category)}
                        className={`d-flex align-items-center my-1 ${!(!!storeOrders.orderDishes[props.restaurant.slug] &&
                          !!storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid]) && 'pl-2'}`}
                      >
                        <div style={{lineHeight: 1.2, width: 'max-content'}}>
                          <b>{translateRecord(v, 'name')}</b><br/>
                          { !!v.weight && v.name.replace(/[a-zA-Zа-яА-Я]/g, '') !== v.weight &&
                            <small>{v.weight}{t(`measures.${v['measure']}`)}</small>}
                          { !props.category.price && !!storeOrders.orderDishes[props.restaurant.slug] &&
                              !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid] &&
                            <span className='btn-light btn-rounded px-1 ml-1'>
                              x<strong>{storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid].quantity}</strong>
                            </span>}
                        </div>
                        { !props.category.price &&
                          <span className='btn-xxs p-1 ml-1 btn fs-18' style={{color: '#2f2d2a'}}>
                            <strong>{dishVariationPrice(v)}</strong><small>₴</small>
                          </span>}
                      </div>
                      <div className='pl-1 mr-1' style={{height: '40px', borderRadius: '10px', lineHeight: 3}}
                           onClick={() => !props.category.price && (!!storeOrders.orderDishes[props.restaurant.slug] &&
                            !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid] ?
                                props.countDishVariation(props.dish, v, 1) : props.selectDishVariation(props.dish, v, props.category))}
                      >
                        { !(!!props.category.price && !!storeOrders.orderDishes[props.restaurant.slug] &&
                            !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid]) &&
                          <span className={`btn-rounded btn-xxs 
                            ${!props.acceptOutsideOrders && !props.table && 'd-none '}
                            ${!!storeOrders.orderDishes[props.restaurant.slug] &&
                              !!storeOrders.orderDishes[props.restaurant.slug].dishes[v.uid] ? 'btn-success' : 'btn-primary'}`}
                                  style={{padding: '9px 4px 0'}}
                          >
                            <span className='fs-28'><b>+</b></span>
                          </span>}
                      </div>
                    </Button>)}
                </div>
              </div>
            :
              <div className="d-block text-center" style={{zIndex: 1}}>
                <h4 className="mb-0 fs-20 d-inline-block">
                  <span style={{color: (!!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ||
                      (props.restaurant.menu_type === 'full' && !props.noPhoto && !!props.dish.photo)) ? 'white' : '#2F2D2A'}}
                  >
                    {dishPrice()}<small><small>₴</small></small>
                  </span>
                </h4>
              </div>}

            { Object.keys(props.dish.dish_variations).length === 0 &&
              <>
                { props.fromDashboard || (props.category.available && props.dish.available && props.variationsAvailable(props.dish)) ?
                  <div className="d-block text-center" style={{position: 'relative', zIndex: 2}}>
                    { storeOrders.orderDishes && storeOrders.orderDishes[props.restaurant.slug] &&
                        storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid] ?
                      <div className='d-flex align-items-center justify-content-end'>
                        <Button className='btn-light py-2 px-3'
                                onClick={() => props.handleDishOrderCount(props.dish, -props.calculateCount(props.dish))}
                        >
                          <Minus fill='black'/>
                        </Button>
                        <Button className='ml-1 mr-1 dish-count btn-light'
                                onClick={() => {props.fromDashboard && setState({...state, showQuantityModal: true})}}
                        >
                          <strong style={{color: "#3e4954"}}>
                            { Number.isInteger(parseFloat(storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid].quantity)) ?
                              storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid].quantity
                            :
                              storeOrders.orderDishes[props.restaurant.slug].dishes[props.dish.uid].quantity.toFixed(2)}
                          </strong>
                          {props.dish.weight_flag && <small>{t(`measures.${props.dish['measure']}`)}</small>}
                        </Button>
                        <Button className='btn-success py-2 px-3'
                                onClick={() => props.handleDishOrderCount(props.dish, props.calculateCount(props.dish))}
                        >
                          <Plus fill='white'/>
                        </Button>
                      </div>
                    :
                      <Button onClick={() => props.handleAddDishToOrder(props.dish, props.category)}
                        className={`btn-primary py-2 px-3 ${!props.acceptOutsideOrders && !props.table && 'd-none'}`}
                      >
                        <Plus fill='white'/>
                      </Button>}
                  </div>
                :
                  <Button className={`btn-primary py-2 px-3 ${!props.acceptOutsideOrders && !props.table && 'd-none'}`}
                          disabled={true}
                  >
                    <Plus fill='white'/>
                  </Button>}
            </>}
          </div>
        </div>}

      {/*Modifications modal*/}

      { state.showModificationsModal &&
        <Modal className="fade" show={state.showModificationsModal}>
          <Modal.Header style={{justifyContent: 'center'}}>
            <Modal.Title>
              <h3 className='text-black mb-0'>{props.dish.name}: Додатки</h3>
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, showModificationsModal: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            { Object.keys(props.dish.dish_variations).length > 0 ?
              <>
                { Object.values(props.dish.dish_variations).map((vary) =>
                  <>
                    { Object.keys(storeOrders.orderDishes[props.restaurant.slug].dishes).includes(vary.uid) &&
                      <>
                        <h4 className='text-center'>Варіант: {vary.name}</h4>
                        {groupMods(vary)}
                      </>}
                  </>
                )}
              </>
            :
              <>
                {groupMods()}
              </>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-lg btn-primary w-100'
                    onClick={() => setState({...state, showModificationsModal: false})}
            >
              Зберегти
            </Button>
          </Modal.Footer>
        </Modal>}

      {/*Quantity modal*/}

      { state.showQuantityModal &&
        <Modal className="fade" show={state.showQuantityModal}
               onEntered={() => textarea.current.focus()}
        >
          <Modal.Header style={{justifyContent: 'center'}}>
            <Modal.Title>
              <h3 className='text-black mb-0'>{props.dish.name}: кількість</h3>
            </Modal.Title>
            <Button variant="" className="close" onClick={() => setState({...state, showQuantityModal: false})}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className='input-group'>
              <input className='form-control' value={state.quantity} placeholder='Введіть число' ref={textarea}
                     onChange={(e) => setState({...state, quantity: e.target.value})} type='number' step={1} min={0}
              />
              <div className='input-group-append'>
                <span className='input-group-text text-black'>
                  {t(`measures.${props.dish.weight_flag ? props.dish['measure'] : 'pcs'}`)}
                </span>
              </div>
            </div>
            { !props.dish.weight_flag &&
              <div className='mt-3'>
                <Button className='btn-warning btn-xs mr-2' onClick={() => setState({...state, quantity: 0.5})}>
                  Пів порції
                </Button>
                <Button className='btn-warning btn-xs' onClick={() => setState({...state, quantity: 1.5})}>
                  Півтори порції
                </Button>
              </div>}
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-lg btn-primary w-100'
                    onClick={() => {
                      if (state.quantity > 0) {
                        handleDishOrderQuantity(props.dish, state.quantity);
                        setState({...state, showQuantityModal: false})
                      } else {
                        handleError(['Кількість має бути більше 0'])
                      }
                    }}
            >
              Зберегти
            </Button>
          </Modal.Footer>
        </Modal>}
    </>
  );
};

export default Dish;